module.exports = __webpack_public_path__ + "media/sub3-2.85430946.mp4";